// Not sensitive event data therefore ignoring the semgrep rule.
export function hideWidget(shouldMoveFocus) {
  // sends post to parent
  // nosemgrep: wildcard-postmessage-configuration
  window.parent.postMessage('hideWidget', '*');
  // nosemgrep: wildcard-postmessage-configuration
  if (shouldMoveFocus) window.parent.postMessage('moveFocus', '*');
}

export function showWidget() {
  // sends post to parent
  // nosemgrep: wildcard-postmessage-configuration
  window.parent.postMessage('showWidget', '*');
}
